<template>
  <li
    class="tree-view-wrapper"
    :class="isFolder ? 'font-weight-bold' : ''"
  >
    <ul
      class="cat-list"
      @click="toggle"
    >
      <li>
        <router-link
          :to="{ name: 'Category', params: { id: item.id, slug: item.slug } }"
          exact
          :class="{ 'main-category': !item.parentCategoryId }"
        >
          <span class="mr-1">{{ item.label }}</span>
          <span v-if="item.parentCategoryId">({{ getNumberOfArticles(item) }})</span>
        </router-link>
        <span class="pointer-cursor" v-if="isFolder">[{{ isListOpen ? '-' : '+' }}]</span>
      </li>
    </ul>
    <ul class="cat-list" v-show="isListOpen" v-if="isFolder">
      <tree-view
        class="item"
        v-for="(child, index) in item.children"
        :key="index"
        :item="child"
        :is-open="isOpenFilter(child)"
      ></tree-view>
    </ul>
  </li>
</template>
<script>
export default {
  name: 'TreeView',
  props: {
    item: Object,
    isOpen: Boolean,
  },
  data() {
    return {
      isListOpen: this.isOpen,
    };
  },
  computed: {
    isFolder() {
      return this.item.children && this.item.children.length;
    },
  },
  methods: {
    toggle() {
      if (this.isFolder) {
        this.isListOpen = !this.isListOpen;
      }
    },
    isOpenFilter(item) {
      const routeId = parseInt(this.$route.params.id, 10);
      if (item.id === routeId) {
        return true;
      }
      if (item.children?.length) {
        for (let i = 0; i < item.children?.length; i += 1) {
          const foundCat = this.isOpenFilter(item.children[i]);
          if (foundCat) {
            return true;
          }
        }
      }
      return false;
    },
    getNumberOfArticles(obj) {
      let count = obj.numberOfArticles || 0; // count the number of articles in the current object
      if (obj.children) { // if there are child objects, count their articles recursively
        for (let i = 0; i < obj.children.length; i += 1) {
          count += this.getNumberOfArticles(obj.children[i]);
        }
      }
      return count;
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  padding-left: 1rem;
  margin: 1rem;
  font-weight: normal;
}

.tree-view-wrapper {
  margin-bottom: 0.5rem;
  list-style: none;
}

.router-link-exact-active.active {
  font-weight: bold;
}

.pointer-cursor {
  cursor: pointer;
}

li a.active,
.main-category  {
  color: #000;
}
</style>
